import { NgModule } from '@angular/core';
import { FormatNumberPipe } from 'app/pipes/format-number-pipe/format-number.pipe';

@NgModule({
    declarations: [FormatNumberPipe],
    providers: [FormatNumberPipe],
    exports: [FormatNumberPipe],
})
export class FormatNumberPipeModule {
}